import React from 'react'
import PropTypes from 'prop-types'
import { FMF_FM, FMF_M } from '../../constants/programConstants'

function SecondPragraph() {
  return (
    <span>
      Cancellation requests within 24 hours or no-shows will be charged at 1 day
      program cost and rest of the days could be either refunded 90% or 100%
      credited towards a future visit at the Isha Institute of Inner-sciences or
      an Isha Program in the US within 1 year of transfer date.
    </span>
  )
}

function CancellationPolicy({ program, variant = 'default' }) {
  return (
    <span>
      {variant === 'email' ? (
        <span>
          <strong>Cancellation Policy:</strong>
          <br />
          <br />
        </span>
      ) : (
        <span>
          <strong>Cancellation/Transfer Policy:</strong>{' '}
        </span>
      )}
      <strong>Cancellation/Transfer Policy:</strong> Registrations must be
      canceled by creating a ticket through
      <a href='https://support.ishafoundation.org/'>
        https://support.ishafoundation.org/
      </a>
      . Select "Isha Centers" - Isha Institute of Inner-Sciences and select
      "visiting" under the support category drop down.
      <br />
      <br />
      Cancellation requests at least 24 hours prior to your arrival date, by 12
      PM CST can receive a 90% refund or a 100% credit towards a future stay at
      the Isha Institute of Inner-sciences or any Isha Program in the US within
      1 year of transfer date.
      <br />
      <br />
      <SecondPragraph />
    </span>
  )
}

CancellationPolicy.defaultProps = {
  showAsSubpoint: false
}
CancellationPolicy.propTypes = {
  showAsSubpoint: PropTypes.bool
}

export default CancellationPolicy



// WEBPACK FOOTER //
// ./src/components/content/cancellationPolicy.js